'use client'

import dynamic from 'next/dynamic'

import { useConfirmStore } from '@/core/lib/confirm'
import { useLoaderStore } from '@/core/stores/loader.store'
import { useModalStore } from '@/core/stores/modal.store'
import { useToastStore } from '@/core/stores/toast.store'

const ToastProvider = dynamic(
  () => import('@/core/components/toast/toast-provider'),
  { ssr: false }
)
const ModalContainer = dynamic(
  () => import('@/core/components/modal/modal-container'),
  { ssr: false }
)
const Loader = dynamic(() => import('@/core/components/loader'), {
  ssr: false,
})
const ConfirmDialog = dynamic(
  () => import('@/core/components/confirm-dialog'),
  { ssr: false }
)

export default function ClientOverlays() {
  const hasToasts = useToastStore((state) => state.toasts.length > 0)
  const hasModals = useModalStore((state) => state.modals.length > 0)
  const isLoading = useLoaderStore((state) => state.isLoading.status)
  const isConfirmOpen = useConfirmStore((state) => state.open || state.closing)

  return (
    <>
      {hasModals && <ModalContainer />}
      {isConfirmOpen && <ConfirmDialog />}
      {hasToasts && <ToastProvider />}
      {isLoading && <Loader />}
    </>
  )
}
